var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 160.763,
    height: 81.452,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 163,
    height: 163,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1926",
    "data-name": "Groupe 1926",
    transform: "translate(-927 -7688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1920",
    "data-name": "Groupe 1920",
    transform: "translate(928 7725.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1919",
    "data-name": "Groupe 1919",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_688",
    "data-name": "Trac\\xE9 688",
    d: "M27.364,16.022a7.175,7.175,0,1,1,7.175-7.173,7.183,7.183,0,0,1-7.175,7.173m0-12.832a5.658,5.658,0,1,0,5.658,5.659,5.665,5.665,0,0,0-5.658-5.659",
    transform: "translate(10.442 0.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 1.517,
    height: 50.266,
    transform: "translate(28.316 29.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_689",
    "data-name": "Trac\\xE9 689",
    d: "M43.194,43.727a4.515,4.515,0,0,1-4.509-4.511V35.643H40.2v3.573a2.992,2.992,0,1,0,5.984,0V23.406a8.643,8.643,0,0,0-8.631-8.631H23.869a8.642,8.642,0,0,0-8.633,8.631V39.216a2.992,2.992,0,1,0,5.984,0V35.643h1.517v3.573a4.509,4.509,0,1,1-9.018,0V23.406a10.16,10.16,0,0,1,10.15-10.149H37.554A10.161,10.161,0,0,1,47.7,23.406V39.216a4.515,4.515,0,0,1-4.509,4.511",
    transform: "translate(7.095 6.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 1.517,
    height: 50.266,
    transform: "translate(45.779 29.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 1.517,
    height: 26.722,
    transform: "translate(13.533 53.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_690",
    "data-name": "Trac\\xE9 690",
    d: "M11.5,22.347a6.108,6.108,0,1,1,6.107-6.11,6.116,6.116,0,0,1-6.107,6.11m0-10.7a4.591,4.591,0,1,0,4.59,4.59,4.6,4.6,0,0,0-4.59-4.59",
    transform: "translate(2.79 5.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 1.517,
    height: 26.722,
    transform: "translate(20.813 53.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_691",
    "data-name": "Trac\\xE9 691",
    d: "M3.886,45.442A3.891,3.891,0,0,1,0,41.555V28.375a8.6,8.6,0,0,1,8.589-8.587h9.643v1.517H8.589a7.08,7.08,0,0,0-7.072,7.07v13.18a2.368,2.368,0,1,0,4.737,0V38.577H7.771v2.978a3.891,3.891,0,0,1-3.886,3.887",
    transform: "translate(0 10.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 1.517,
    height: 41.797,
    transform: "translate(6.254 37.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 1.517,
    height: 35.216,
    transform: "translate(37.047 44.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_692",
    "data-name": "Trac\\xE9 692",
    d: "M40.683,45.735,33.528,38.58,34.6,37.507l6.082,6.082,13.26-13.259L47.2,23.585l1.074-1.073,7.815,7.818Z",
    transform: "translate(17.341 11.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_693",
    "data-name": "Trac\\xE9 693",
    d: "M62.659,62.959h-.076A3.893,3.893,0,0,1,59.9,61.8L41.613,43.522a3.287,3.287,0,0,1-.927-1.816l-.4-2.479a1.082,1.082,0,0,0-.3-.59L38.184,36.83l1.074-1.073,1.8,1.805a2.6,2.6,0,0,1,.727,1.426l.4,2.478a1.775,1.775,0,0,0,.5.982L60.968,60.732a2.388,2.388,0,0,0,1.646.71,2.235,2.235,0,0,0,1.582-.628,2.158,2.158,0,0,0,.628-1.582,2.39,2.39,0,0,0-.71-1.646l-3.872-3.872,1.073-1.073,3.872,3.872A3.9,3.9,0,0,1,66.342,59.2a3.664,3.664,0,0,1-3.682,3.758",
    transform: "translate(19.749 18.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_694",
    "data-name": "Trac\\xE9 694",
    d: "M60.652,55.771a3.717,3.717,0,0,1-2.643-1.092l-5.286-5.284L53.8,48.321l5.286,5.284a2.221,2.221,0,1,0,3.141-3.141l-5.284-5.284,1.073-1.073,5.284,5.284a3.735,3.735,0,0,1-2.643,6.378",
    transform: "translate(27.268 22.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_695",
    "data-name": "Trac\\xE9 695",
    d: "M63.43,52.994A3.717,3.717,0,0,1,60.787,51.9L55.5,46.617l1.073-1.073,5.286,5.284A2.221,2.221,0,0,0,65,47.688L59.716,42.4l1.073-1.073,5.284,5.284a3.735,3.735,0,0,1-2.643,6.378",
    transform: "translate(28.705 21.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_696",
    "data-name": "Trac\\xE9 696",
    d: "M66.205,49.739a3.708,3.708,0,0,1-2.641-1.1l-5.286-5.284,1.073-1.073,5.286,5.284a2.272,2.272,0,0,0,3.139,0,2.216,2.216,0,0,0,0-3.141L63.9,40.554l1.073-1.073,3.875,3.876a3.738,3.738,0,0,1-2.643,6.381",
    transform: "translate(30.141 20.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_697",
    "data-name": "Trac\\xE9 697",
    d: "M56.631,34.28l-1.59-1.59a.67.67,0,0,0-.452-.194l-3.119-.088a2.853,2.853,0,0,1-1.937-.834l-3.045-3.047,1.073-1.073L50.6,30.5a1.332,1.332,0,0,0,.909.391l3.122.088a2.175,2.175,0,0,1,1.479.639l1.59,1.59Z",
    transform: "translate(24.043 14.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_698",
    "data-name": "Trac\\xE9 698",
    d: "M51.735,45.5a3.776,3.776,0,0,1-2.672-6.447l7.97-7.968a2.459,2.459,0,0,1,1.581-.718l4.811-.313a1.542,1.542,0,0,0,1-.454L66.8,27.231,67.875,28.3,65.5,30.674a3.062,3.062,0,0,1-1.98.9l-4.81.313a.949.949,0,0,0-.605.275l-7.971,7.97a2.26,2.26,0,0,0,3.2,3.2l6.283-6.283,3.544.088v2.133A3.545,3.545,0,0,0,66.7,42.8h1.229a3.545,3.545,0,0,0,3.541-3.541V38.5h1.517v.759a5.065,5.065,0,0,1-5.058,5.058H66.7a5.065,5.065,0,0,1-5.058-5.058v-.654l-1.413-.035L54.406,44.4A3.765,3.765,0,0,1,51.735,45.5",
    transform: "translate(24.805 14.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_699",
    "data-name": "Trac\\xE9 699",
    d: "M43.744,49.47a3.045,3.045,0,0,1-2.154-5.2l2.393-2.391,4.307,4.309L45.9,48.579a3.033,3.033,0,0,1-2.154.891m.238-5.445-1.32,1.318a1.532,1.532,0,0,0,0,2.164,1.566,1.566,0,0,0,2.164,0l1.318-1.318Z",
    transform: "translate(21.049 21.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_700",
    "data-name": "Trac\\xE9 700",
    d: "M45.878,51.6a3.045,3.045,0,0,1-2.154-5.2l2.391-2.391,4.309,4.309-2.391,2.391a3.036,3.036,0,0,1-2.154.891m.237-5.445L44.8,47.476a1.532,1.532,0,0,0,0,2.164,1.566,1.566,0,0,0,2.164,0l1.318-1.318Z",
    transform: "translate(22.153 22.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_701",
    "data-name": "Trac\\xE9 701",
    d: "M48.01,53.736a3.045,3.045,0,0,1-2.154-5.2l2.393-2.391,4.309,4.309-2.393,2.391a3.036,3.036,0,0,1-2.154.891m.238-5.445-1.32,1.318a1.532,1.532,0,0,0,0,2.164,1.566,1.566,0,0,0,2.164,0l1.32-1.318Z",
    transform: "translate(23.256 23.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_702",
    "data-name": "Trac\\xE9 702",
    d: "M50.143,55.868a3.045,3.045,0,0,1-2.154-5.2l2.393-2.391,4.307,4.309L52.3,54.977a3.036,3.036,0,0,1-2.154.891m.238-5.445-1.32,1.318A1.53,1.53,0,1,0,51.225,53.9l1.318-1.318Z",
    transform: "translate(24.359 24.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_703",
    "data-name": "Trac\\xE9 703",
    d: "M65.2,46.385l-1.073-1.073,2.761-2.761a1.469,1.469,0,0,0,.429-.98l.055-1.364a2.436,2.436,0,0,1,.707-1.619L71.1,35.575l1.073,1.073-3.015,3.012a.917.917,0,0,0-.264.611l-.055,1.364a2.991,2.991,0,0,1-.874,1.989Z",
    transform: "translate(33.169 18.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_704",
    "data-name": "Trac\\xE9 704",
    d: "M74.253,45.183,58.847,29.777l7.815-7.817,1.073,1.073-6.742,6.744,13.26,13.26,3.788-3.79,1.073,1.073Z",
    transform: "translate(30.436 11.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_705",
    "data-name": "Trac\\xE9 705",
    d: "M76.637,31.593H75.119v-.759c0-16.166-7.019-29.317-15.647-29.317S43.827,14.668,43.827,30.834v.759H42.31v-.759C42.31,13.832,50.01,0,59.473,0S76.637,13.832,76.637,30.834Z",
    transform: "translate(21.883 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 1.517,
    height: 31.593,
    transform: "translate(80.597 0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 52.394,
    height: 1.517,
    transform: "translate(55.212 15.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 55.084,
    height: 1.517,
    transform: "translate(53.281 30.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_706",
    "data-name": "Trac\\xE9 706",
    d: "M93.049,27.473l-.1-.751a29.323,29.323,0,0,0-57.567-2.637l-.173.739-1.478-.349.174-.737a30.84,30.84,0,0,1,60.545,2.773l.1.751Z",
    transform: "translate(17.443 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_707",
    "data-name": "Trac\\xE9 707",
    d: "M97.382,75.5,86.124,67.595a36.966,36.966,0,0,1-15.7-30.218V21.845l4.989-.956A42.6,42.6,0,0,0,92.07,13.93l5.509-3.84,4.755,3.439a42.6,42.6,0,0,0,16.5,7.251l5.506,1.129V37.743a36.269,36.269,0,0,1-15.4,29.645Zm-10.387-9.15,10.387,7.3,10.684-7.506a34.743,34.743,0,0,0,14.756-28.4v-14.6l-4.294-.88a44.087,44.087,0,0,1-17.084-7.509l-3.881-2.807-4.627,3.224a44.15,44.15,0,0,1-17.241,7.205l-3.754.718V37.377A35.457,35.457,0,0,0,86.995,66.354",
    transform: "translate(36.423 5.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_708",
    "data-name": "Trac\\xE9 708",
    d: "M95.523,66.57l-8.194-5.758A31.341,31.341,0,0,1,74.017,35.191V24.049l.851-.158a46.779,46.779,0,0,0,18.287-7.653l2.509-1.746,1.8,1.3a46.8,46.8,0,0,0,18.15,7.976l1.417.291V35.549a30.655,30.655,0,0,1-13.021,25.058ZM75.534,25.308v9.883A29.825,29.825,0,0,0,88.2,59.571l7.322,5.145,7.615-5.351a29.135,29.135,0,0,0,12.374-23.816V25.3l-.2-.041a48.354,48.354,0,0,1-18.734-8.235l-.925-.669-1.625,1.13a48.274,48.274,0,0,1-18.489,7.824",
    transform: "translate(38.282 7.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_709",
    "data-name": "Trac\\xE9 709",
    d: "M89.027,46.074l-9.234-9.235,5.256-5.256,3.978,3.98,11-11,5.256,5.256Zm-7.088-9.235,7.088,7.09,14.105-14.105-3.11-3.11-11,11-3.978-3.98Z",
    transform: "translate(41.269 12.707)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1922",
    "data-name": "Groupe 1922",
    transform: "translate(927 7688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1921",
    "data-name": "Groupe 1921",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M148.824,123.7a79.414,79.414,0,0,1-134.649,0H11.8a81.46,81.46,0,0,0,139.4,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_711",
    "data-name": "Trac\\xE9 711",
    d: "M11.574,43.7a79.474,79.474,0,0,1,139.852,0h2.246a81.444,81.444,0,0,0-144.345,0Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/Hands.acbc630d23a53ace1276f321b783c95c.svg";
export { ForwardRef as ReactComponent };